export default __webpack_public_path__ + "static/media/gosk.a15efd34.jfif";